/**
 * Representative of all of the model types as defined in Ember.  It's
 * slightly non-standard, but since virtually every reference to model types/names
 * in Ember is either case-agnostic or Capitalized, we use the capitalized value here.
 *
 * @const
 */
export const MODEL_TYPES = {
  COMPANY: 'Company',
  USER: 'User'
};
